export default "__VITE_ASSET__BwV1nm4g__"